import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=35801b74&scoped=true&"
import script from "./NavigationItem.vue?vue&type=script&lang=ts&"
export * from "./NavigationItem.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationItem.vue?vue&type=style&index=0&id=35801b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35801b74",
  null
  
)

export default component.exports